'use strict';

import { Alert } from '@material-ui/lab';
import React, { Component } from 'react';
import PopUp from '../../commonModules/interface/PopUp';

var $ = require('jquery');

class ValidationOverlay extends Component{
    state = {      
        popupState: this.props.popupStateButton, 
        msg: this.props.msg,errormsg:""
    }
    componentWillReceiveProps(nextProps) {
        // You don't have to do this check first, but it can help prevent an unneeded render
        if (nextProps.popupStateButton !== this.state.popupState) {
            this.setState({popupState: nextProps.popupStateButton});
        }
    }
    cancel = async (e) => {
        e.preventDefault();
        console.log("Cancel Validation");
        // this.setState({popupState: "overlay hidden",errormsg:""});
        this.props.onCancelation();
    }
    valid = async (e) => {
        e.preventDefault();
        var urlValidation = this.props.url

        this.serverRequest = $.get(urlValidation, function(result) {
            console.log('[INFO],  reception front of Validation: ');
            console.log(result);
            if (result.error === 'OK') {
                // this.setState({popupState: "overlay hidden"});
                if ( this.props.fetchAlerts ) {
                    this.props.fetchAlerts();
                }
                this.props.onValidation();
            } else {
                this.setState({
                    errormsg: 'Error : ' + result.error
                });
            }
        }.bind(this));
    }

    componentWillUnmount() {
        try {
            this.serverRequest.abort();
        } catch (e) {
            console.log(e);
        }
    }
    render() {
        console.log("[DEBUG], Menu,Validation, Button Proceed");
        return (
            // <div className={this.state.popupState}>
            //     <div className="popup">
            <PopUp
                close={this.cancel}
                submitAction={this.valid}
                title={this.props.title || "Confirmation"}
            >
                    <p>{this.props.msg}</p>
                    {this.state.errormsg &&
                        <Alert severity="error">{this.state.errormsg}</Alert>
                    }
                    {/* <div className="text-right">
                        <button className="btn btn-cancel" onClick={this.cancel}>Cancel</button>
                        <button className="btn btn-primary" onClick={this.valid}>Ok</button>
                    </div> */}

            </PopUp>
            //     </div>
            // </div>
        );
    }
}
export default ValidationOverlay
